import { Sport } from '../../models/sport.model';
import { SportIconName } from '../sportsbook.models';

export const DEFAULT_SPORT_ORDER: readonly number[] = [
  Sport.SOCCER,
  Sport.TENNIS,
  Sport.BASKETBALL,
  Sport.ICE_HOCKEY,
  Sport.BASEBALL,
  Sport.MOTORSPORT,
  Sport.DART
];

const SPORT_META: Partial<Record<Sport, { label: string; iconName: SportIconName }>> = {
  [Sport.SOCCER]: { label: 'Soccer', iconName: 'soccer' },
  [Sport.TENNIS]: { label: 'Tennis', iconName: 'tennis' },
  [Sport.BASKETBALL]: { label: 'Basketball', iconName: 'basketball' },
  [Sport.ICE_HOCKEY]: { label: 'Ice Hockey', iconName: 'ice-hockey' },
  [Sport.BASEBALL]: { label: 'Baseball', iconName: 'baseball' },
  [Sport.MOTORSPORT]: { label: 'Motorsport', iconName: 'motorsport' },
  [Sport.DART]: { label: 'Darts', iconName: 'darts' },
  [Sport.FOOTBALL]: { label: 'Football', iconName: 'football' },
  [Sport.HANDBALL]: { label: 'Handball', iconName: 'handball' },
  [Sport.RUGBY]: { label: 'Rugby', iconName: 'rugby' },
  [Sport.WINTERSPORT]: { label: 'Winter Sport', iconName: 'winter-sport' },
  [Sport.TABLE_TENNIS]: { label: 'Table Tennis', iconName: 'table-tennis' },
  [Sport.VOLLEYBALL]: { label: 'Volleyball', iconName: 'volleyball' },
  [Sport.BEACHVOLLEYBALL]: { label: 'Beach Volleyball', iconName: 'volleyball' },
  [Sport.E_SOCCER]: { label: 'eSoccer', iconName: 'soccer' },
  [Sport.E_BASKETBALL]: { label: 'eBasketball', iconName: 'basketball' },
  [Sport.E_ICE_HOCKEY]: { label: 'eIce Hockey', iconName: 'ice-hockey' }
};

export function getSportPresentation(sportId: number): { label: string; iconName: SportIconName } {
  const metadata = SPORT_META[sportId as Sport];
  if (metadata) {
    return metadata;
  }

  const enumLabel = Sport[sportId as Sport];
  return {
    label: typeof enumLabel === 'string'
      ? enumLabel
        .toLowerCase()
        .split('_')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ')
      : '',
    iconName: 'generic'
  };
}
